import { useQuery } from 'react-query';
import { Axios } from '@utils/api/axios-instance';
import { GET_URL } from '@utils/api/endpoints';

export type OrgAiSummaryQuota = {
  organization_id: number;
  organization_name: string;
  monthly_limit_override: number | null;
  quota: {
    enabled: boolean;
    limit: number | null;
    used: number;
    reserved: number;
    remaining: number | null;
    reset_at: string | null;
  };
};

export const useGetOrgAiSummaryQuota = (orgId: number | string) => {
  return useQuery<OrgAiSummaryQuota>(
    ['sysopOrgAiSummaryQuota', orgId],
    async () => {
      const { data } = await Axios.get(
        GET_URL(String(orgId)).sysopOrgAiSummaryQuota
      );
      return data;
    },
    { enabled: !!orgId, staleTime: 30_000 }
  );
};
